/* Vinanest editorial: Contact + Wholesale pages (sections/vne-contact.liquid, sections/vne-wholesale.liquid).
   The forms are plain Shopify contact forms and post without this script; this adds:
   - checks in Vietnamese/English (name, phone: empty or not 10 digits, email only if typed), phone formatting as you type;
   - the store email as contact[email] when the customer has none (Shopify requires one), plus "no email given";
   - one "products" line instead of a line per ticked box, no empty lines for optional fields left blank,
     the reading language, select labels in VI/EN;
   - the thank-you text with the customer's number and chosen channel, a draft kept across an error reload;
   - the order reminder (paid items in the cart → "View order"), and a one-button call bar while no call button is on screen.
   Uses window.VNE (vinanest-editorial.js) when it is ready, for analytics, the order drawer and the cart. */
(function () {
  'use strict';
  var W = window, H = document.documentElement, B = document.body;
  var KEY = 'vne_contact', DRAFT = 'vne_contact_draft';
  var page = document.querySelector('[data-vc-page]');
  if (!page) return;
  var KIND = page.getAttribute('data-vc-page');
  var REDUCE = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function qa(s, el) { return Array.prototype.slice.call((el || page).querySelectorAll(s)); }
  function q(s, el) { return (el || page).querySelector(s); }
  function isEn() { return H.getAttribute('data-vne-lang') === 'en'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bi(vi, en) { return '<span class="vi">' + esc(vi) + '</span><span class="en">' + esc(en) + '</span>'; }
  function nb(s) { return String(s).replace(/ /g, ' ').replace(/-/g, '‑'); }
  function ss(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function api() { return W.VNE || null; }
  function track(n, d) { var v = api(); if (v) v.track(n, d); else try { (W.dataLayer = W.dataLayer || []).push(Object.assign({ event: 'vn_' + n }, d || {})); } catch (e) {} }
  function pixel(ev, d) { var v = api(); if (v) v.pixel(ev, d); else try { if (W.fbq) W.fbq('track', ev, d || {}); } catch (e) {} }
  function scrollToEl(el, off) { if (!el) return; W.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + W.scrollY - (off || 16)), behavior: REDUCE ? 'auto' : 'smooth' }); }

  /* ---------- phone helpers (same rules as the call-back form in the main script) ---------- */
  function digits(s) { var d = String(s || '').replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); return d; }
  function fmtPhone(s) { var d = digits(s); return d.length === 10 ? '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6) : String(s || '').trim(); }
  function asYouType(raw) {
    if (/^\s*\+/.test(raw) && !/^\s*\+1/.test(raw)) return raw;   /* a number from abroad: leave it as typed */
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length > 10) return raw;
    if (d.length < 4) return d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  function phoneOk(v) { var d = digits(v); return d.length === 10 || (/^\s*\+/.test(v) && d.length >= 10 && d.length <= 15); }
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()); }

  /* ---------- select labels + placeholders follow the reading language (also done by the main script; kept here so the form never depends on it) ---------- */
  function paintSelects() {
    var en = isEn();
    qa('select option[data-vi]').forEach(function (o) { var t = o.getAttribute(en ? 'data-en' : 'data-vi'); if (t && o.textContent !== t) o.textContent = t; });
    qa('[data-vi-ph]').forEach(function (el) { var t = el.getAttribute(en ? 'data-en-ph' : 'data-vi-ph'); if (t != null && el.placeholder !== t) el.placeholder = t; });
  }

  /* ---------- forms ---------- */
  function setErr(form, which, on) {
    var input = q('[data-vc-in="' + which + '"]', form), msg = q('[data-vc-err="' + which + '"]', form);
    if (msg) msg.hidden = !on;
    if (input) { if (on) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  function fields(form) {
    var o = {};
    qa('input[data-vc-in], textarea[data-vc-in], select[data-vc-in]', form).forEach(function (el) { o[el.getAttribute('data-vc-in')] = el.value; });
    o.prods = qa('[data-vc-prod]', form).filter(function (c) { return c.checked; }).map(function (c) { return c.getAttribute('data-vc-prod'); });
    var pr = q('[data-vc-prefv]:checked', form); o.pref = pr ? pr.getAttribute('data-vc-prefv') : 'call';
    return o;
  }
  function restore(form, d) {
    if (!d) return;
    qa('input[data-vc-in], textarea[data-vc-in], select[data-vc-in]', form).forEach(function (el) { var k = el.getAttribute('data-vc-in'); if (d[k] != null && !el.value) el.value = d[k]; });
    qa('[data-vc-prod]', form).forEach(function (c) { c.checked = (d.prods || []).indexOf(c.getAttribute('data-vc-prod')) > -1; });
    var r = q('[data-vc-prefv="' + (d.pref || 'call') + '"]', form); if (r) r.checked = true;
  }
  function wire(form) {
    var kind = form.getAttribute('data-vc-form');
    form.noValidate = true;   /* our own messages instead of the browser's (the inputs keep `required` for no-script visitors) */
    var phone = q('[data-vc-in="phone"]', form), name = q('[data-vc-in="name"]', form), email = q('[data-vc-in="email"]', form);
    if (phone) phone.addEventListener('input', function () {
      var v = asYouType(phone.value);
      if (v !== phone.value) phone.value = v;
      if (phone.getAttribute('aria-invalid') && phoneOk(phone.value)) setErr(form, 'phone', false);
      if (phone.value.trim()) { var e0 = q('[data-vc-err="phone0"]', form); if (e0 && !e0.hidden) { e0.hidden = true; if (!q('[data-vc-err="phone"]:not([hidden])', form)) phone.removeAttribute('aria-invalid'); } }
    });
    if (name) name.addEventListener('input', function () { if (name.value.trim()) setErr(form, 'name', false); });
    if (email) email.addEventListener('input', function () { if (!email.value.trim() || emailOk(email.value)) setErr(form, 'email', false); });
    form.addEventListener('submit', function (e) {
      var badName = name && !name.value.trim(), badPhone = phone && !phoneOk(phone.value), ev = email ? email.value.trim() : '', badEmail = !!ev && !emailOk(ev);
      /* an empty phone asks for the number; a wrong one explains the 10-digit format */
      var emptyPhone = !!(phone && !phone.value.trim()), e0 = q('[data-vc-err="phone0"]', form);
      setErr(form, 'name', !!badName); setErr(form, 'phone', !!badPhone && !(emptyPhone && e0)); setErr(form, 'email', badEmail);
      if (e0) { e0.hidden = !emptyPhone; if (emptyPhone) phone.setAttribute('aria-invalid', 'true'); }
      if (badName || badPhone || badEmail) {
        e.preventDefault();
        var first = badName ? name : badPhone ? phone : email;
        scrollToEl(first.closest('.vc-f') || first, 24);
        first.focus({ preventScroll: true });
        track(kind + '_invalid', { name: !!badName, phone: !!badPhone, email: badEmail });
        return;
      }
      if (phone) phone.value = fmtPhone(phone.value);
      /* Shopify needs contact[email]: without one, send the store's own address and say so */
      var fb = q('[data-vc-fallback]', form), ne = q('[data-vc-noemail]', form);
      if (email) {
        if (ev) { email.value = ev; email.setAttribute('name', 'contact[email]'); if (fb) fb.disabled = true; if (ne) ne.disabled = true; }
        else { email.removeAttribute('name'); if (fb) fb.disabled = false; if (ne) ne.disabled = false; }
      }
      var lf = q('[data-vc-langfield]', form); if (lf) lf.value = isEn() ? 'English' : 'Tiếng Việt';
      /* one "products" line in the email instead of a line per ticked box */
      var sum = q('[data-vc-prodsum]', form), picks = qa('[data-vc-prod]', form);
      if (sum && picks.length) {
        var on = picks.filter(function (c) { return c.checked; }).map(function (c) { return c.getAttribute('data-vc-prod'); });
        picks.forEach(function (c) { if (!c.getAttribute('data-vc-name')) c.setAttribute('data-vc-name', c.name); c.removeAttribute('name'); });
        sum.value = on.join(', ');
        sum.disabled = !on.length;
      }
      /* optional fields left blank: leave them out, so the store's email has no empty "Business:" / "City:" lines
         (contact[body] is Shopify's own message field and always goes, even when empty) */
      qa('input[data-vc-in]:not([type=email]), select[data-vc-in]', form).forEach(function (el) {
        if (!el.required && el.name && !el.value.trim()) { el.setAttribute('data-vc-name', el.name); el.removeAttribute('name'); }
      });
      var f = fields(form);
      ss(KEY, { kind: kind, name: (f.name || '').trim(), phone: phone ? phone.value : '', pref: f.pref, t: Date.now(), sent: false });
      ss(DRAFT, f);
      var btn = q('[data-vc-send]', form);
      if (btn) {
        btn.disabled = true;
        var l = q('.vc-send-l', btn), w = q('.vc-send-w', btn); if (l) l.hidden = true; if (w) w.hidden = false;
        /* back/forward cache: give the button back if the visitor returns to this page */
        W.addEventListener('pageshow', function () {
          btn.disabled = false; if (l) l.hidden = false; if (w) w.hidden = true;
          qa('[data-vc-prod][data-vc-name], [data-vc-in][data-vc-name]', form).forEach(function (c) { var n = c.getAttribute('data-vc-name'); if (n && !c.getAttribute('name')) c.setAttribute('name', n); });
        }, { once: true });
      }
      track(kind + '_submit', { pref: f.pref, email: !!ev, products: (f.prods || []).length });
    });
  }
  qa('form[data-vc-form]').forEach(wire);

  /* ---------- after Shopify reloads the page ---------- */
  function cleanUrl() {
    try {
      var u = new URL(W.location.href);
      if (!u.searchParams.has('contact_posted')) return;
      u.searchParams.delete('contact_posted');
      history.replaceState(null, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash.replace(/^#(contact_form|ContactForm|WholesaleForm|vne-cb-form)$/, ''));
    } catch (e) {}
  }
  var done = q('[data-vc-done]');
  if (done) {
    var info = ss(KEY) || {}, fresh = info.t && Date.now() - info.t < 60 * 60 * 1000;
    var kind = fresh && info.kind ? info.kind : done.getAttribute('data-vc-kind');
    /* the wholesale form may land back on the contact page (Shopify can drop ?view=): say what was actually sent */
    qa('[data-vc-variant]', done).forEach(function (p) { p.hidden = p.getAttribute('data-vc-variant') !== kind; });
    var target = q('[data-vc-variant="' + kind + '"]', done) || q('[data-vc-donetext]', done);
    if (fresh && info.phone && target) {
      var ph = nb(fmtPhone(info.phone)), hv = page.getAttribute('data-vc-hours-vi') || '', he = page.getAttribute('data-vc-hours-en') || '';
      var whenVi = hv ? ' trong giờ làm việc (' + hv + ', giờ California)' : ' trong giờ làm việc', whenEn = he ? ' during business hours (' + he + ' Pacific time)' : ' during business hours';
      var what = kind === 'wholesale' ? ['yêu cầu báo giá sỉ', 'your wholesale request'] : ['lời nhắn', 'your message'];
      var how = info.pref === 'zalo' ? ['sẽ nhắn Zalo cho số ' + ph, 'will message ' + ph + ' on Zalo']
        : info.pref === 'sms' ? ['sẽ nhắn tin tới số ' + ph, 'will text ' + ph]
        : ['sẽ gọi lại số ' + ph, 'will call ' + ph];
      target.innerHTML = bi('Vinanest đã nhận ' + what[0] + ' và ' + how[0] + whenVi + '.', 'We’ve received ' + what[1] + ' and ' + how[1] + whenEn + '.');
    }
    if (fresh && !info.sent) {
      info.sent = true; ss(KEY, info);
      track(kind + '_sent', { pref: info.pref });
      pixel(kind === 'wholesale' ? 'Lead' : 'Contact', { content_name: kind === 'wholesale' ? 'wholesale-form' : 'contact-form' });
    }
    ss(DRAFT, null);
    cleanUrl();
    var land = function () { scrollToEl(q('.vc-panel') || done, 12); try { done.focus({ preventScroll: true }); } catch (e) {} };
    if (document.readyState === 'complete') setTimeout(land, 60); else W.addEventListener('load', function () { setTimeout(land, 60); });
  }
  var alertEl = q('[data-vc-alert]');
  if (alertEl) {
    var fm = alertEl.closest('form');
    if (fm) { restore(fm, ss(DRAFT)); var em = q('[data-vc-in="email"]', fm); if (em && em.value.trim() && !emailOk(em.value)) setErr(fm, 'email', true); }
    cleanUrl();
    var show = function () { scrollToEl(alertEl, 24); try { alertEl.focus({ preventScroll: true }); } catch (e) {} };
    if (document.readyState === 'complete') setTimeout(show, 60); else W.addEventListener('load', function () { setTimeout(show, 60); });
    track(KIND + '_error');
  }

  /* in-page links to the form: land with the first field ready */
  page.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vc-toform]');
    if (a) {
      var t = document.getElementById('vc-form');
      if (!t) return;
      e.preventDefault();
      scrollToEl(t, 8);
      var first = q('form[data-vc-form] input[data-vc-in="name"]');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) {} }, REDUCE ? 0 : 450);
      try { history.replaceState(null, '', '#vc-form'); } catch (x) {}
      return;
    }
    var c = e.target.closest && e.target.closest('[data-vc-cartopen]');
    if (c) { var v = api(); if (v) v.openDrawer(); else W.location.href = '/cart'; }
  });

  /* ---------- order reminder ---------- */
  var note = q('[data-vc-cart]');
  function paintCart() {
    var v = api();
    if (!note || !v) return;
    var n = v.count(), c = v.cart() || {};
    note.hidden = !(n > 0);
    var t = q('[data-vc-carttotal]', note);
    if (t && n > 0) t.textContent = v.money(c.total_price || 0);
  }
  document.addEventListener('vne:cart', paintCart);

  /* ---------- one-button call bar: shown while no call button, the form's send button or the footer is on screen ---------- */
  var bar = q('[data-vc-bar]'), root = document.getElementById('vne');
  if (bar && root && 'IntersectionObserver' in W) {
    root.appendChild(bar);   /* next to the shared dialogs, like the site's own bar (fixed + text-size zoom behave the same) */
    var seen = new Set(), typing = false;
    var link = bar.querySelector('a');
    var paintBar = function () {
      var on = seen.size === 0 && !typing && !B.classList.contains('vne-lock');
      bar.classList.toggle('vne-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      if (link) link.tabIndex = on ? 0 : -1;
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) seen.add(x.target); else seen.delete(x.target); });
      paintBar();
    });
    qa('[data-vc-callmain], [data-vc-hidebar]').forEach(function (el) { io.observe(el); });
    var foot = document.querySelector('.vne-foot'); if (foot) io.observe(foot);
    page.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input:not([type=radio]):not([type=checkbox]), textarea, select')) { typing = true; paintBar(); } });
    page.addEventListener('focusout', function () { typing = false; setTimeout(paintBar, 120); });
    if ('MutationObserver' in W) new MutationObserver(paintBar).observe(B, { attributes: true, attributeFilter: ['class'] });
    var mo = function () { if (link) link.setAttribute('aria-label', (isEn() ? 'Call ' : 'Gọi ') + (link.textContent.match(/\(\d{3}\)\s?\d{3}-\d{4}/) || [''])[0]); };
    mo();
    if ('MutationObserver' in W) new MutationObserver(function () { mo(); paintSelects(); }).observe(H, { attributes: true, attributeFilter: ['data-vne-lang'] });
  } else if ('MutationObserver' in W) {
    new MutationObserver(paintSelects).observe(H, { attributes: true, attributeFilter: ['data-vne-lang'] });
  }

  paintSelects();
  function onReady() { paintCart(); }
  if (W.VNE) onReady(); else document.addEventListener('vne:ready', onReady);
})();
